import request from '@/utils/request'

// 查询质量提升-标准服务-威海市地方标准列表
export function listZltsHggj(query) {
  return request({
    url: '/web/zlts/bzfw/zltsHggj/list',
    method: 'get',
    params: query
  })
}

// 查询质量提升-标准服务-威海市地方标准列表
export function getInfo(query) {
  return request({
    url: '/web/zlts/bzfw/zltsHggj/getInfo',
    method: 'get',
    params: query
  })
}

